import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiDialog: {
            defaultProps: {
                maxWidth: 'md',
            },
            styleOverrides: {
                root: {
                    '.MuiPaper-root': {
                        background: designTokens.color.shade.white.value,
                        boxShadow: "".concat(theme.spacing(0, 0.5, 1), " rgba(0, 0, 0,0.08)"),
                        borderRadius: theme.spacing(0.5),
                    },
                    '.MuiBackdrop-root': {
                        backgroundColor: designTokens.color.gray.obsidian,
                    },
                    '.MuiDialog-paperFullScreen': {
                        borderRadius: 0,
                    },
                },
            },
        },
        MuiDialogTitle: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    overflowWrap: 'anywhere',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: theme.spacing(3),
                    paddingTop: theme.spacing(3),
                    fontSize: designTokens.typography.heading.h6.size.value,
                    fontWeight: designTokens.typography.heading.sub.fontWeight.value,
                    lineHeight: designTokens.typography.heading.h6.lineHeight.value,
                    color: designTokens.color.shade.black.value,
                    // to maintain position of XCloseIcon when {children} wrap to multiple lines
                    '.MuiIconButton-root': {
                        alignSelf: 'flex-start',
                    },
                },
            },
        },
        MuiDialogContent: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    paddingBottom: '0',
                },
            },
        },
        MuiDialogContentText: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    fontSize: designTokens.typography.body.long1.size.value,
                    lineHeight: designTokens.typography.body.long1.lineHeight.value,
                    color: designTokens.color.shade.black.value,
                    paddingBottom: theme.spacing(0.5),
                },
            },
        },
        MuiDialogActions: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=dialogTheme.js.map